import React from 'react';

const MoreHorizontal = (props: object) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 5C8.96446 5 8.125 4.16054 8.125 3.125C8.125 2.08946 8.96446 1.25 10 1.25C11.0355 1.25 11.875 2.08946 11.875 3.125C11.875 4.16054 11.0355 5 10 5ZM10 11.875C8.96446 11.875 8.125 11.0355 8.125 10C8.125 8.96446 8.96446 8.125 10 8.125C11.0355 8.125 11.875 8.96446 11.875 10C11.875 11.0355 11.0355 11.875 10 11.875ZM8.125 16.875C8.125 17.9105 8.96446 18.75 10 18.75C11.0355 18.75 11.875 17.9105 11.875 16.875C11.875 15.8395 11.0355 15 10 15C8.96446 15 8.125 15.8395 8.125 16.875Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default MoreHorizontal;
